.container {
  display: flex;
  width: 100%;
  flex-direction: row;
}
